import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Users, Upload, AlertCircle } from 'lucide-react';

const C2CEligibility = () => {
  return (
    <section id="eligibility" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Who Can Join?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            Exclusive program for students and NYSC members
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <GraduationCap className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Final-Year Students</h3>
                <p className="text-gray-600">
                  Currently enrolled in your final year at any Nigerian university, polytechnic, or college of education.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Users className="h-6 w-6 text-green-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">NYSC Members</h3>
                <p className="text-gray-600">
                  Currently serving or recently completed your National Youth Service Corps program.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Upload className="h-6 w-6 text-purple-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Required Documents</h3>
                <p className="text-gray-600">
                  Must upload valid Student ID or NYSC ID card during registration.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-8"
          >
            <div className="text-center">
              <AlertCircle className="h-16 w-16 text-blue-600 mx-auto mb-6" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Important Note</h3>
              <p className="text-gray-600 mb-6">
                This program is exclusively designed for students and NYSC members to provide them with early exposure to export opportunities and career development.
              </p>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h4 className="font-bold text-gray-900 mb-2">Verification Required</h4>
                <p className="text-sm text-gray-600">
                  All applicants must provide valid identification to confirm eligibility. This ensures the program reaches its intended audience.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default C2CEligibility;